import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, 
  ReactiveFormsModule, AbstractControl, ValidationErrors } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';

import { Customers } from '../../Customers/models/customers';
import { CustomersService } from '../../Service/customers-service';
import { UdcsService } from '../../Service/udcs-service';
import { UppercaseDirective } from '../../util/uppercase'; // <-- 1. Importa el archivo
import { ToastService } from '../../Service/toast-service';
import { Observable, of } from 'rxjs';
import { map, catchError, debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-customer-edit',
  standalone: true, 
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule, 
    MatInputModule,
    UppercaseDirective
  ],
  templateUrl: './customer-edit.html',
  styleUrl: './customer-edit.css',
})
export class CustomerEdit implements OnInit {

  customerForm!: FormGroup; // Se inicializa formalmente mediante initForm()

  // 💡 SOLUCIÓN: Control reactivo de la pestaña activa en pantalla
  activeTab: string = 'identidad'; 

  // 🌟 CONTROL EXCLUSIVO EDIT: Almacena el RFC con el que el cliente fue abierto
  rfcOriginal: string = '';  

  // Catálogos estáticos homologados con el Alta
  tiposPersona: { codigo: string; descripcion: string; tipo: 'FISICA' | 'MORAL' }[] = [
  // 👤 PERSONAS FÍSICAS (RFC de 13 dígitos)
  { codigo: '605', descripcion: 'FISICA - Sueldos y Salarios e Ingresos Asimilados', tipo: 'FISICA' },
  { codigo: '606', descripcion: 'FISICA - Arrendamiento', tipo: 'FISICA' },
  { codigo: '612', descripcion: 'FISICA - Actividades Empresariales y Profesionales', tipo: 'FISICA' },
  { codigo: '625', descripcion: 'FISICA - Actividades Empresariales con ingresos por Plataformas Tecnológicas', tipo: 'FISICA' },
  { codigo: '626', descripcion: 'FISICA - Régimen Simplificado de Confianza (RESICO)', tipo: 'FISICA' },
  { codigo: '616', descripcion: 'FISICA - Sin obligaciones fiscales (Público en General / Extranjero)', tipo: 'FISICA' },

  // 🏢 PERSONAS MORALES (RFC de 12 dígitos)
  { codigo: '601', descripcion: 'MORAL - General de Ley Personas Morales', tipo: 'MORAL' },
  { codigo: '603', descripcion: 'MORAL - Personas Morales con Fines no Lucrativos', tipo: 'MORAL' },
  { codigo: '620', descripcion: 'MORAL - Sociedad Cooperativa de Producción', tipo: 'MORAL' },
  { codigo: '623', descripcion: 'MORAL - Régimen Opcional para Grupos de Sociedades', tipo: 'MORAL' },
  { codigo: '624', descripcion: 'MORAL - Coordinados (Transporte)', tipo: 'MORAL' }
  ];  
  estatusAprobacion: string[] = ['PENDIENTE', 'APROBADO', 'RECHAZADO'];
  metodosPago: string[] = ['PUE', 'PPD'];
  formasPago: string[] = ['01', '03', '04', '28', '99']; 
  tiposMoneda: string[] = ['MXN', 'USD', 'EUR'];

  // Catálogos dinámicos alimentados por UDCs
  girosEconomicos: any[] = [];
  paises: any[] = [];
  estados: any[] = [];
  mostrarDesplegableEstado: boolean = true; 

  // 💡 SUGERENCIA DE ROLES: Estructura semilla simulada para el futuro control JDE
  // Cambia estos booleanos a true/false para probar cómo se apagan o prenden las pestañas
  rolesPermisos = {
    puedeEditarGenerales: true,
    puedeEditarDomicilio: true,
    puedeEditarCredito: true,
    puedeEditarContactos: true
  };  

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CustomerEdit>,
    //@Inject(MAT_DIALOG_DATA) public data: Customers,
    // 🚀 SOLUCIÓN 1: Cambiado de 'public data: Customers' a 'public data: any'
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private customerService: CustomersService,
    private udcsService: UdcsService,
    private dcr: ChangeDetectorRef, // Mapeado a tu cdr interno
    private cdr: ChangeDetectorRef,
    public toastService: ToastService
  ) {
    this.initForm();
  }

	ngOnInit(): void {
    console.group('🔍 [DIAGNÓSTICO JDE] Carga de datos en ngOnInit');
    this.escucharCambioPais(); // 🌟 AGREGADO: Escucha telefónica JDE
    this.escucharErroresRfc(); // 🌟 AGREGADO: Escucha proactiva de Toasts para el RFC

    // 1. Descargamos secuencialmente los catálogos UDC primero
    this.udcsService.getGirosEconomicos().subscribe({
      next: (girosData) => {
        this.girosEconomicos = girosData;

        this.udcsService.getPaisesMundo().subscribe({
          next: (paisesData) => {
            this.paises = paisesData;

            // 2. SÓLO CUANDO LOS CATÁLOGOS YA ESTÁN LISTOS, traemos el DTO plano del cliente
            if (this.data && this.data.an8) {
              this.customerService.getCustomer(this.data.an8).subscribe({
                next: (dtoPlanoBackend: any) => {
                  console.log('📥 DTO Plano y Sincronizado recibido de Java:', dtoPlanoBackend);
                  
                  // Homologaciones SAT de compatibilidad
                  dtoPlanoBackend.fisicaMoral = dtoPlanoBackend.tax2 || '601';

                  if (dtoPlanoBackend.rfc) {
                    this.rfcOriginal = dtoPlanoBackend.rfc.trim().toUpperCase();
                  }

                  // Tratamiento seguro de Fecha Solicitud
/*                   if (dtoPlanoBackend.fechaSolicitud) {
                    try {
                      const d = new Date(dtoPlanoBackend.fechaSolicitud);
                      dtoPlanoBackend.fechaSolicitud = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
                    } catch (e) { dtoPlanoBackend.fechaSolicitud = ''; }
                  } */

                  // 🚀 UN SOLO PATCH EN TODO EL COMPONENTE: Sella todas las pestañas de golpe sin borrarse
                  this.customerForm.patchValue(dtoPlanoBackend);

                  // Sincronizamos selectores geográficos
                  if (dtoPlanoBackend.country) {
                    this.sincronizarEstadoInicial(dtoPlanoBackend.country, dtoPlanoBackend.estado);
                  }
                  
                  this.cdr.detectChanges();
                },
                error: (err) => console.error('Error cargando DTO individual', err)
              });
            }
          },
          error: (err) => console.error('Error al descargar el catálogo de países:', err)
        });
      },
      error: (err) => console.error('Error al descargar el catálogo de giros económicos:', err)
    });
    console.groupEnd();

/*     console.log('Objeto anidado crudo recibido:', this.data);

    console.groupEnd();

    // 💡 PASO : Descargamos primero todas las UDCs y catálogos desde el servidor.
    // Esto garantiza que las listas de Giros, Métodos y Formas de Pago ya habiten en memoria.
    this.cargarCatalogosUDC();


    if (this.data && this.data.an8) { //if (this.data) {
      // 💡 PASO : Clonamos el objeto de entrada para formatear variables sin alterar tu listado principal
      //const copiaData = { ...this.data };
      const an8AEditar = this.data.an8;

      // Consumimos el endpoint individual que ahora regresa el DTO plano lleno de todas las tablas
      this.customerService.getCustomer(an8AEditar).subscribe({
        next: (dtoPlanoBackend: any) => {
          console.log('📥 DTO de todas las tablas JDE recuperado plano:', dtoPlanoBackend);
          
          // Sello de compatibilidad para el selector de régimen fiscal SAT
          dtoPlanoBackend.fisicaMoral = dtoPlanoBackend.tax2 || '601';

          // Resguardo del RFC base para el antibloqueo
          if (dtoPlanoBackend.rfc) {
            this.rfcOriginal = dtoPlanoBackend.rfc.trim().toUpperCase();
          }

          // Tratamiento de Fecha Solicitud
          console.log('1. [Fecha Solicitud] Valor original recibido:', dtoPlanoBackend.fechaSolicitud);

          // Tratamiento de Fecha Solicitud
          if (dtoPlanoBackend.fechaSolicitud) {
            try {
              const d = new Date(dtoPlanoBackend.fechaSolicitud);
              console.log('2. [Fecha Solicitud] Objeto Date creado exitosamente:', d.toString());
              dtoPlanoBackend.fechaSolicitud = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
              console.log('3. [Fecha Solicitud] Cadena formateada final (YYYY-MM-DDTHH:mm):', dtoPlanoBackend.fechaSolicitud);
            } catch (e) { 
              console.error('X. [Fecha Solicitud] Error al intentar parsear o formatear la fecha:', e);
              dtoPlanoBackend.fechaSolicitud = ''; }
          } else {
            console.log('!. [Fecha Solicitud] No se procesó porque el valor viene vacío o es falsy.');
          }

          // 🚀 LA MAGIA: El patchValue funciona a la primera porque el JSON es plano igual al initForm()
          this.customerForm.patchValue(dtoPlanoBackend);

          // Disparador de estados en cascada
          if (dtoPlanoBackend.country) {
            this.sincronizarEstadoInicial(dtoPlanoBackend.country, dtoPlanoBackend.estado);
          }
          this.cdr.detectChanges();
        },
        error: (err) => console.error('Error cargando DTO individual', err)
      });
    }
    console.groupEnd(); */
  }



  private initForm(): void {
    this.customerForm = this.fb.group({
      // =========================================================================
      // REFACTORIZACIÓN CORE: IDENTIFICADOR CENTRAL AN8 (REEMPLAZA ID Y ADDRESS)
      // =========================================================================

      // Único identificador de negocio bloqueado e intocable
      an8: [{ value: null, disabled: true }, [Validators.required]], 

      rfc: [
        '', 
        [Validators.required, Validators.pattern('^[A-Z&Ññ]{3,4}[0-9]{6}[A-Z0-9]{3}$')],
        [this.validarRfcUnico.bind(this)]
      ],             
      email: ['', [Validators.required, Validators.email]],
      name: ['', Validators.required],
      razonSocial: ['', Validators.required],
      fisicaMoral: ['601', [Validators.required]], // 🌟 Mantenido obligatorio para cruce cruzado
      
      giroEmpresa: [''],
      webSite: [''],
      
      // Bloque 2: Domicilio Fiscal
      calleNumero: ['', Validators.required],
      colonia: ['', Validators.required],
      codigoPostal: ['', [Validators.required, Validators.pattern('^[0-9]{5}$')]],
      delegacionMnicipio: ['', Validators.required],
      ciudad: ['', Validators.required],
      estado: ['', Validators.required],
      country: ['MX'],
      telefonoDF: [''],
      
      // Bloque 3: Parámetros de Crédito y Tesorería
      diasCredito: ['0'],
      currencyCode: ['MXN'],
/*       
      diasCreditoActual: ['0'],
      diasCreditoAnterior: ['0'],
      currCodeCxC: ['MXN'],
      
      tasaIva: ['16'],
      paymentMethod: [''],
      formaPago: [''],
      acceptOpenOrder: [false, Validators.required], */
      //fechaSolicitud: [{ value: '', disabled: true }],
      //fechaAprobacion: [''],

      nombreContactoCxC: [''], 
      emailContactoCxC: ['', [Validators.email]],
      telefonoContactoCxC: [''],

      nombreContactoPedidos: [''],
      emailContactoPedidos: ['', [Validators.email]],
      telefonoContactoPedidos: [''],
      
      nombreContactoVentas: [''], 
      emailContactoVentas: ['', [Validators.email]],
      telefonoContactoVentas: [''],

      nombreContactoCompras: [''],
      emailCompras: ['', [Validators.email]],
      telefonoCompras: [''],

      nombreContactoCxP01: [''],
      emailCxP01: ['', [Validators.email]],
      telefonoCxP01: [''], 

      // ... Conserva el resto de tus más de 60 campos de control para no perder consistencia
      // Espejos y campos de control remanentes para no romper consistencia
      approvalStatus: [''],
      rejectNotes: [''],

      compradorAsignado: [''], batchNumber: [''], riesgoCategoria: [''], observaciones: [''], 

      fechaAprobacion: [''],

/*       currentApprover: [''], nextApprover: [''], approvalStep: [''],
      ukuid: [0, Validators.required], steps: [0, Validators.required],
       approvalNotes: [''], 
      regiones: [''], categorias: [''], categoriaJDE: [''], tipoMovimiento: [''],
        faxDF: [''], cargoCxC: [''], faxCxC: [''],
      creditMessage: [''], taxAreaCxC: [''], taxExpl2CxC: [''], pmtTrmCxC: [''], payInstCxC: [''],
      catCode15: [''], catCode27: [''], nombreCxP01: [''], */

/*       tipoIdentificacion: [''], numeroIdentificacion: [''], nombreRL: [''], apellidoPaternoRL: [''],
      apellidoMaternoRL: [''], bankTitleRepName: [''], bankName: [''], cuentaClabe: [''],
      bankAccountNumber: [''], swiftCode: [''], ibanCode: [''], glClass: [''], bankTransitNumber: [''],
      custBankAcct: [''], controlDigit: [''], description: [''], checkingOrSavingAccount: [''],
      rollNumber: [''], bankAddressNumber: [''], bankCountryCode: [''], nombreBanco: [''],
      nombreContactoCalidad: [''], emailContactoCalidad: [''], telefonoContactoCalidad: [''], puestoCalidad: [''],
      direccionPlanta: [''], direccionCentroDistribucion: [''], tipoProductoServicio: [''],  */
      
/*       taxRate: [''], explCode1: [''], invException: [''], supplierType: [''],
      automaticEmail: [''], fileList: [''], emailComprador: [''], taxId: [''],
      faxNumber: [''], legalRepIdType: [''], legalRepIdNumber: [''], legalRepName: [''], industryClass: [''],
      hold: [''], outSourcing: [false, Validators.required], outSourcingAccept: [false, Validators.required],
      outSourcingMonthlyAccept: [false, Validators.required], outSourcingBimonthlyAccept: [false, Validators.required],
      outSourcingQuarterlyAccept: [false, Validators.required], supplierWithoutOC: [false, Validators.required],
      supplierWithOC: [false, Validators.required], outSourcingRecordDate: [null] */

    }, {
      validators: [this.validadorRfcRegimen.bind(this)] 
    });
  }

  // 🌟 NUEVO: Validador Asíncrono de RFC Único Inteligente para Edición
  private validarRfcUnico(control: AbstractControl): Observable<ValidationErrors | null> {
    if (!control.value || control.value.trim() === '') return of(null);
    const rfcLimpio = control.value.trim().toUpperCase();

    // 🟢 CLAVE DE PROTECCIÓN: Si el valor es el mismo que recuperamos de la base de datos, pasa libre
    if (rfcLimpio === this.rfcOriginal || rfcLimpio === 'XAXX010101000') {
      return of(null);
    }

    return this.customerService.verificarRfcDuplicado(rfcLimpio).pipe(
      map((existe: boolean) => existe ? { rfcDuplicado: true } : null),
      catchError(() => of(null))
    );
  }

  // 🌟 NUEVO: Escuchador reactivo de Toasts automatizados por inconsistencia fiscal
  private escucharErroresRfc(): void {
    const rfcControl = this.customerForm.get('rfc');
    if (rfcControl) {
      rfcControl.valueChanges.pipe(
        debounceTime(600),
        distinctUntilChanged()
      ).subscribe(() => {
        if (rfcControl.hasError('rfcDuplicado')) {
          this.toastService.showDanger(
            'Bloqueo por Duplicidad Fiscal',
            `El RFC [${rfcControl.value.toUpperCase()}] ya pertenece a otro cliente registrado en esta compañía.`
          );
          rfcControl.markAsTouched();
          this.cdr.detectChanges(); 
        }

        if (rfcControl.hasError('rfcRegimenInvalido')) {
          const mensajeCustom = rfcControl.getError('rfcRegimenInvalido');
          this.toastService.showDanger('Incongruencia Fiscal SAT', `⚠️ ${mensajeCustom}`);
          rfcControl.markAsTouched();
          this.cdr.detectChanges();
        }        
      });
    }
  }

  // 🌟 NUEVO: Validador Cruzado de Consistencia SAT
  private validadorRfcRegimen(group: AbstractControl): ValidationErrors | null {
    const rfcControl = group.get('rfc');
    const regimenControl = group.get('fisicaMoral');

    if (!rfcControl || !regimenControl || !rfcControl.value) return null;

    const rfcLimpio = rfcControl.value.toString().trim().toUpperCase();
    const longitudRfc = rfcLimpio.length;
    
    if (rfcLimpio === 'XAXX010101000') return null;

    const regimenInfo = this.tiposPersona.find(r => r.codigo === regimenControl.value);
    if (!regimenInfo) return null;

    let error: ValidationErrors | null = null;

    if (longitudRfc === 12 && regimenInfo.tipo === 'FISICA') {
      error = { rfcRegimenInvalido: 'Persona Moral no puede vincularse a un régimen de Persona Física.' };
    } else if (longitudRfc === 13 && regimenInfo.tipo === 'MORAL') {
      error = { rfcRegimenInvalido: 'Persona Física no puede vincularse a un régimen de Personas Morales.' };
    } else if (longitudRfc > 0 && longitudRfc !== 12 && longitudRfc !== 13) {
      error = { rfcRegimenInvalido: 'Estructura inválida. El RFC en México debe tener 12 o 13 caracteres.' };
    }

    if (error) {
      rfcControl.setErrors({ ...rfcControl.errors, ...error });
      regimenControl.setErrors({ ...regimenControl.errors, ...error });
    } else {
      if (rfcControl.errors) {
        const { rfcRegimenInvalido, ...rest } = rfcControl.errors;
        rfcControl.setErrors(Object.keys(rest).length ? rest : null);
      }
      if (regimenControl.errors) {
        const { rfcRegimenInvalido, ...rest } = regimenControl.errors;
        regimenControl.setErrors(Object.keys(rest).length ? rest : null);
      }
    }
    return error;
  }


  // 🌟 NUEVO: Sincronización telefónica por País
  private escucharCambioPais(): void {
    const paisControl = this.customerForm.get('country');
    const telCentral = this.customerForm.get('telefonoDF');
    if (paisControl) {
      this.ajustarValidadorTelefono(paisControl.value, telCentral);
      paisControl.valueChanges.subscribe(nuevoPais => {
        this.ajustarValidadorTelefono(nuevoPais, telCentral);
      });
    }
  }  

  private ajustarValidadorTelefono(pais: string, controlTelefono: any): void {
    if (!controlTelefono) return;
    if (pais && (pais.toUpperCase().trim() === 'MEXICO' || pais.toUpperCase().trim() === 'MX')) {
      controlTelefono.setValidators([Validators.pattern('^[0-9]{10}$')]);
    } else {
      controlTelefono.setValidators([Validators.pattern('^[0-9]*$')]);
    }
    controlTelefono.updateValueAndValidity({ emitEvent: false });
  }

  /**
   * Escucha el cambio directo del dropdown de País en el HTML.
   * Conmuta la visibilidad del select vs input libre y dispara la cascada.
   */
  onPaisCambiado(event: any): void {
    const codigoPais = event.target.value;
    const estadoControl = this.customerForm.get('estado');

    if (codigoPais === 'MX' || codigoPais === 'US') {
      this.mostrarDesplegableEstado = true;
      this.cargarEstadosCascada(codigoPais);
    } else {
      this.mostrarDesplegableEstado = false;
      this.estados = [];
      estadoControl?.setValue(''); // Libera la casilla para captura manual libre
    }
    this.cdr.detectChanges();
  }

  /**
   * 🚀 FUNCIÓN COMPLEMENTARIA: Consume el servicio UDC para traer los estados
   * de forma segmentada y consistente con el país seleccionado.
   */
  cargarEstadosCascada(codigoPais: string): void {
    // Invocamos a tu udcsService para traer la lista filtrada desde la BD
    this.udcsService.getEstadosPorPais(codigoPais).subscribe({
      next: (data) => {
        this.estados = data; // Almacena [{ description: 'JALISCO' }, ...]
        this.cdr.detectChanges(); // Fuerza a Angular a pintar las opciones en el select
      },
      error: (err) => console.error('Error al recuperar estados en cascada para la edición:', err)
    });
  }

  /**
   * Método operativo para bloquear letras físicamente en el teclado
   */
  soloNumeros(event: KeyboardEvent): boolean {
    const charCode = event.key;
    if (!/^[0-9]$/.test(charCode)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

private cargarCatalogosUDC(): void {
    //console.log('>>> [ERP JDE] Iniciando descarga secuencial de catálogos UDC...');

    // 💡 PASO 1: Descargamos primero el catálogo de Giros Económicos
/*     this.udcsService.getGirosEconomicos().subscribe({
      next: (girosData) => {
        this.girosEconomicos = girosData;
 */
        // 💡 PASO 2: SÓLO CUANDO LOS GIROS YA ESTÁN EN MEMORIA, descargamos los Países del Mundo
/*         this.udcsService.getPaisesMundo().subscribe({
          next: (paisesData) => {
            this.paises = paisesData; */

            // 💡 PASO 3: AHORA SÍ, con todos los catálogos listos, inyectamos de forma segura el cliente
/*             if (this.data) {
              console.log('>>> [ERP JDE] Catálogos listos. Aplicando patchValue al formulario.');      */        

              // 💡 SOLUCIÓN A LA FECHA VACÍA: Clonamos y formateamos antes del segundo patch asíncrono
              //const copiaAsincrona = { ...this.data };

              // 🚀 SOLUCIÓN 3: Cambia 'const copiaAsincrona = { ...this.data };' por:
/*               const copiaAsincrona: any = { ...this.data };
          
              const fechaCruda = copiaAsincrona.fechaSolicitud || (copiaAsincrona as any).fechaAlta;
              
              if (fechaCruda) {
                try {
                  const d = new Date(fechaCruda);
                  const anio = d.getFullYear();
                  const mes = String(d.getMonth() + 1).padStart(2, '0');
                  const dia = String(d.getDate()).padStart(2, '0');
                  const horas = String(d.getHours()).padStart(2, '0');
                  const minutos = String(d.getMinutes()).padStart(2, '0');
                  copiaAsincrona.fechaSolicitud = `${anio}-${mes}-${dia}T${horas}:${minutos}`;

                  console.log('🚀 [DIAGNÓSTICO FECHA] 3. Formato ISO en cargarCatalogosUDC:', copiaAsincrona.fechaSolicitud);
                } catch(e) {
                  copiaAsincrona.fechaSolicitud = '';
                }
              } */

              // =========================================================================
              // 🛡️ RE-APLANAMIENTO EN CARGA ASÍNCRONA (ESCUDO ANTIBORRADO)
              // Desarmamos el JSON jerárquico y lo repartimos plano antes del patchValue
              // =========================================================================
/*               const idAsinc = copiaAsincrona.identidadGlobal;
              if (idAsinc) { */
                // --- PESTAÑA 1: IDENTIDAD CORE ---
/*                 copiaAsincrona.name = idAsinc.nameAlpha || copiaAsincrona.name || '';
                copiaAsincrona.razonSocial = idAsinc.nameAlpha || copiaAsincrona.razonSocial || '';
                copiaAsincrona.rfc = idAsinc.taxId || copiaAsincrona.rfc || '';
                copiaAsincrona.email = idAsinc.email || copiaAsincrona.email || '';
                copiaAsincrona.telefonoDF = idAsinc.phone || copiaAsincrona.telefonoDF || '';
                copiaAsincrona.fisicaMoral = idAsinc.tax2 || copiaAsincrona.fisicaMoral || ''; */

                // --- PESTAÑA 2: DOMICILIO FISCAL (F0116) ---
/*                 copiaAsincrona.calleNumero = copiaAsincrona.calleNumero || idAsinc.calleNumero || '';
                copiaAsincrona.colonia = copiaAsincrona.colonia || idAsinc.colonia || '';
                copiaAsincrona.codigoPostal = copiaAsincrona.codigoPostal || idAsinc.codigoPostal || '';
                copiaAsincrona.delegacionMnicipio = copiaAsincrona.delegacionMnicipio || idAsinc.delegacionMnicipio || '';
                copiaAsincrona.ciudad = copiaAsincrona.ciudad || idAsinc.ciudad || '';
                copiaAsincrona.estado = copiaAsincrona.estado || idAsinc.estado || '';
                copiaAsincrona.country = copiaAsincrona.country || idAsinc.country || 'MX'; */

                // --- PESTAÑA 3: CRÉDITO Y FINANZAS (F03012) ---
/*                 if (idAsinc.finanzasExtension) {
                  copiaAsincrona.paymentMethod = idAsinc.finanzasExtension.paymentMethod || '';
                  copiaAsincrona.formaPago = idAsinc.finanzasExtension.formaPago || '';
                  copiaAsincrona.diasCredito = idAsinc.finanzasExtension.paymentTermsCode || '0';
                  copiaAsincrona.diasCreditoActual = idAsinc.finanzasExtension.paymentTermsCode || '0';
                } */

                // --- PESTAÑA 4: DIRECTORIO DE CONTACTOS (F0111) ---
                // Buscamos los contactos dentro de la lista por su puesto lógicamente
/*                 const listaContactos = idAsinc.contactos || copiaAsincrona.contactos || [];
                
                const contactoCxC = listaContactos.find((c: any) => c.puesto === 'CXC');
                if (contactoCxC) {
                  copiaAsincrona.nombreContactoCxC = contactoCxC.alps;
                  copiaAsincrona.emailContactoCxC = contactoCxC.mail;
                  copiaAsincrona.telefonoContactoCxC = contactoCxC.phne;
                }

                const contactoVentas = listaContactos.find((c: any) => c.puesto === 'VENTAS');
                if (contactoVentas) {
                  copiaAsincrona.nombreContactoVentas = contactoVentas.alps;
                  copiaAsincrona.emailContactoVentas = contactoVentas.mail;
                  copiaAsincrona.telefonoContactoVentas = contactoVentas.phne;
                }

                const contactoCompras = listaContactos.find((c: any) => c.puesto === 'COMPRAS');
                if (contactoCompras) {
                  copiaAsincrona.nombreContactoCompras = contactoCompras.alps;
                  copiaAsincrona.emailCompras = contactoCompras.mail;
                  copiaAsincrona.telefonoCompras = contactoCompras.phne;
                }

                const contactoCxP = listaContactos.find((c: any) => c.puesto === 'CXP');
                if (contactoCxP) {
                  copiaAsincrona.nombreContactoCxP01 = contactoCxP.alps;
                  copiaAsincrona.emailCxP01 = contactoCxP.mail;
                  copiaAsincrona.telefonoContactoCxP01 = contactoCxP.phne;
                }

                const contactoPedidos = listaContactos.find((c: any) => c.puesto === 'PEDIDOS');
                if (contactoPedidos) {
                  copiaAsincrona.nombreContactoPedidos = contactoPedidos.alps;
                  copiaAsincrona.emailContactoPedidos = contactoPedidos.mail;
                  copiaAsincrona.telefonoContactoPedidos = contactoPedidos.phne;
                }

              } */


              // =========================================================================
              // 🛡️ CONTROL ANTIBLOQUEO DE CURSOR AL EDITAR
              // =========================================================================
         //     if (this.customerForm.pristine) {
                // Si el usuario NO ha tocado ningún campo, cargamos el objeto completo normalmente
/*                 this.customerForm.patchValue(copiaAsincrona);
              } else { */
                /**
                 * Si el usuario ya comenzó a escribir (el formulario está 'dirty'), 
                 * actualizamos únicamente la fecha o catálogos específicos de fondo,
                 * evitando pisar campos de texto activos como 'email', 'name' o 'razonSocial'.
                 */
/*                 const fechaControl = this.customerForm.get('fechaSolicitud');
                if (fechaControl && !fechaControl.dirty) {
                  fechaControl.setValue(copiaAsincrona.fechaSolicitud, { emitEvent: false });
                }
              }

              console.group('🔍 [DIAGNÓSTICO FECHA] 4. Estado Final del Formulario');
              console.log('Valor en el control reactivo:', this.customerForm.get('fechaSolicitud')?.value);
              console.log('¿El control está deshabilitado?:', this.customerForm.get('fechaSolicitud')?.disabled);
              console.groupEnd(); */

              // 💡 PASO 4: Sincronizamos la cascada geográfica del Estado guardado de forma segura
/*               if (this.data.country) {
                this.sincronizarEstadoInicial(this.data.country, this.data.estado);
              }
            }
            this.cdr.detectChanges(); // Forzamos a Angular a redibujar las listas en el HTML
          },
          error: (err) => console.error('Error al descargar el catálogo de países:', err)
        });
      },
      error: (err) => console.error('Error al descargar el catálogo de giros económicos:', err)
    }); */
  }

   /**
   * 💡 COMPLEMENTO GEOGRÁFICO: Asegura que el Estado original se cargue y se seleccione 
   * de forma automática al abrir el modal de edición, respetando la condicional de países.
   */
  private sincronizarEstadoInicial(codigoPais: string, estadoGuardado: string): void {
    const estadoControl = this.customerForm.get('estado');

    if (codigoPais === 'MX' || codigoPais === 'US') {
      this.mostrarDesplegableEstado = true;
      
      // Descargamos los estados correspondientes desde tu base de datos
      this.udcsService.getEstadosPorPais(codigoPais).subscribe({
        next: (estadosData) => {
          this.estados = estadosData;
          
          // Re-inyectamos el texto del estado para que el <select> lo marque como seleccionado
          if (estadoGuardado) {
            estadoControl?.setValue(estadoGuardado);
          }
          this.cdr.detectChanges();
        },
        error: (err) => console.error('Error en cascada geográfica inicial:', err)
      });
    } else {
      this.mostrarDesplegableEstado = false;
      this.estados = [];
    }
  }    

    /**
   * 💡 SOLUCIÓN: Cambia de pestaña dinámicamente y fuerza el redibujado visual
   */
  switchTab(tabName: string): void {
    this.activeTab = tabName;
    this.cdr.detectChanges();
  }  

  onSave(): void {
    if (this.customerForm.valid) {
      // getRawValue() garantiza que el AN8 deshabilitado se incluya en el payload JSON hacia Spring Boot
      //const customerModificado: Customers = this.customerForm.getRawValue();
      
      // 🚀 SOLUCCIÓN CRÍTICA: Cambiamos 'const customerModificado: Customers' por tipado libre 'any'
      // Esto disuelve de inmediato los errores ts(2339) al saltarse las restricciones de la interfaz recortada
      const formValues: any = this.customerForm.getRawValue();

      // Clonamos y forzamos mayúsculas preventivas para JDE
      const dtoPlano: any = {};
      Object.keys(formValues).forEach(key => {
        const valor = formValues[key];
        dtoPlano[key] = (typeof valor === 'string') ? valor.trim().toUpperCase() : valor;
      });

      // 🌟 SELLO DE COMPATIBILIDAD CON TU SERVICIO JAVA:
      dtoPlano.tax2 = dtoPlano.fisicaMoral; // Tu Java lee 'dto.getTax2()' para la f03012
      dtoPlano.automaticEmail = dtoPlano.email; // Sincroniza el correo central
      dtoPlano.taxId = dtoPlano.rfc; // Tu Java busca 'dto.getTaxId()' para el RFC de la f0101

      // Banderas de auditoría e identificadores numéricos
      //dtoPlano.fechaSolicitud = (dtoPlano.fechaSolicitud === '') ? null : dtoPlano.fechaSolicitud;

      console.log('✈️ Despachando DTO Plano calibrado hacia CustomersService.java:', dtoPlano);


      // Disparamos la petición PUT real hacia tu backend en el puerto 8085
      this.customerService.updateCustomer(dtoPlano).subscribe({
        next: () => {
          console.log('Confirmación de persistencia exitosa desde el servidor.');
          
          // 💡 REGLA UX MANTENIDA: Si todo sale bien, cerramos el modal y devolvemos 
          // el objeto modificado en mayúsculas al listado. El listado pintará el Toast verde.
          this.dialogRef.close(dtoPlano); 
        },
        error: (err) => {
          console.error('Error fatal al intentar modificar el cliente corporativo:', err);
          
          // 💡 REGLA UX MANTENIDA: Si el servidor lo rechaza (ej. RFC duplicado), el modal
          // permanece abierto y disparamos el Toast flotante rojo interno.
          this.toastService.showDanger(
            'Fallo de Actualización', 
            err.error || 'No se pudieron guardar los cambios en el servidor. Revise los datos.'
          );
          
          this.cdr.detectChanges();
        }
      });
    } else {
      // Si el formulario tiene errores de validación locales en la pestaña actual
      this.customerForm.markAllAsTouched();
      
      this.toastService.showDanger(
        'Formulario Inválido', 
        'Existen casillas obligatorias vacías o con formato incorrecto en esta pestaña.'
      );
      this.cdr.detectChanges();
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }  
}